import md5 from 'md5';
import { notification } from 'antd';

import { gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import { readCookie } from '../../utils/cookies-browser';

const {
  DELETE_DEVICE_HISTORY_SUCCESS,
  DELETE_DEVICE_HISTORY_FAILED,
  FETCH_USER_DEVICES_LIST,
  SET_USER_DEVICES_LIST,
  FETCH_USER_DEVICES_LIST_ERROR,
  SET_DEVICE_HISTORY_DATA,
  FETCH_USER_DEVICE_HISTORY_ERROR,
} = actionTypes;

const deleteDeviceHistorySuccess = createBaseActions(DELETE_DEVICE_HISTORY_SUCCESS, 'result');
const deleteDeviceHistoryError = createBaseActions(DELETE_DEVICE_HISTORY_FAILED, 'reason');
const setUserDevicesListData = createBaseActions(SET_USER_DEVICES_LIST, 'data');
const setDeviceHistoryData = createBaseActions(SET_DEVICE_HISTORY_DATA, 'deviceId', 'data');

export const deleteDeviceHistoryData = (email, devicePk) => async (dispatch, getState) => {
  const {
    locale, localeData,
  } = getState();
  const i18n = localeData[locale];
  try {
    const deviceFootprint = JSON.parse(readCookie('__BINANCE_USER_DEVICE_ID__'));
    let deviceId;
    if (deviceFootprint[md5(email)]) {
      deviceId = deviceFootprint[md5(email)].value;
    } else {
      throw Error('Device footprint not matched.');
    }

    const params = {
      deviceId,
      devicePk,
    };
    let data = await gwPost(API_PATH.DELETE_DEVICE_HISTORY, setPostBody(params));
    data = handleGwData(data);
    notification.success({
      message: i18n.success || 'Device successfully deleted.',
    });
    dispatch(deleteDeviceHistorySuccess(data));
  } catch (error) {
    notification.error({
      message: i18n.failed || 'Device not successfully deleted.',
    });
    dispatch(deleteDeviceHistoryError(error));
  }
};

export const fetchUserDevicesList = () => async dispatch => {
  dispatch({ type: FETCH_USER_DEVICES_LIST });
  try {
    let data = await gwPost(API_PATH.USER_DEVICES_LIST_API_PATH);
    data = handleGwData(data);
    dispatch(setUserDevicesListData(data));
  } catch (error) {
    dispatch({ type: FETCH_USER_DEVICES_LIST_ERROR, error });
  }
};

export const fetchDeviceHistoryData = deviceId => async (dispatch) => {
  dispatch({ type: FETCH_USER_DEVICES_LIST });
  try {
    let data = await gwPost(API_PATH.DEVICE_HISTORY, { devicePk: deviceId });
    data = handleGwData(data);
    dispatch(setDeviceHistoryData(deviceId, Object.freeze(data)));
  } catch (error) {
    dispatch({ type: FETCH_USER_DEVICE_HISTORY_ERROR, error });
  }
};

export default {};
